import { PlayerRequestType } from '@dtvgo/player-common-utils';
import { getParamValueFromUrl } from '@dtvgo/utils';

function hasTokenization(params) {
  if (!params.manifestUrl)
    return false;
  return getParamValueFromUrl(params.manifestUrl, "tokenization") === "true";
}
function getCDNTokenizationConfig(tokenType = []) {
  let cdnToken;
  const useCookie = tokenType.includes("cookie");
  const useHeader = tokenType.includes("header");
  const useQueryParam = tokenType.includes("queryParam");
  const onRequest = (type, request) => {
    if (type !== PlayerRequestType.MANIFEST && type !== PlayerRequestType.SEGMENT)
      return {};
    const modifiedRequest = {};
    if (useCookie) {
      modifiedRequest.allowCrossSiteCredentials = true;
    }
    if (useHeader && cdnToken) {
      modifiedRequest.headers = { hdntl: cdnToken };
    }
    if (useQueryParam && cdnToken) {
      modifiedRequest.uris = request.uris?.map((uri) => {
        const url = new URL(uri);
        url.searchParams.set("hdntl", cdnToken);
        return url.toString();
      });
    }
    return modifiedRequest;
  };
  const onResponseReceived = (type, response) => {
    if ((useHeader || useQueryParam) && response.headers?.hdntl)
      cdnToken = response.headers.hdntl;
  };
  return {
    onRequest,
    onResponseReceived
  };
}

export { getCDNTokenizationConfig, hasTokenization };
//# sourceMappingURL=tokenization.js.map
